__turbopack_context__.v({
  "content": "Stepper-module-scss-module__50oTsa__content",
  "step_count": "Stepper-module-scss-module__50oTsa__step_count",
  "step_line": "Stepper-module-scss-module__50oTsa__step_line",
  "title": "Stepper-module-scss-module__50oTsa__title",
});
